import { ScreenType } from "@package/ui-gql/index-data-access";
import { useSelectorWall } from "@package/ui-redux";
import { useMemo } from "react";
import {
  SCREENS_DIV_ID,
  type ScreenDimension,
} from "../../constants/constants";
import { getScreenDimensions } from "../../utils/get-screen-dimensions";
import { Screen } from "../Screen/Screen";

function ScreenCustom() {
  const screens = useSelectorWall((state) => state.wall.screens);

  return (
    <>
      {screens.map((screen) => (
        <div
          key={screen.id}
          className="absolute overflow-hidden"
          style={{
            top: screen.position?.y ?? 0,
            left: screen.position?.x ?? 0,
            width: screen.position?.width ?? 0,
            height: screen.position?.height ?? 0,
          }}
        >
          <Screen screen={screen} />
        </div>
      ))}
    </>
  );
}

function ScreenTv() {
  const type = useSelectorWall((state) => state.wall.type);
  const profileScreen = useSelectorWall((state) => state.wall.profileScreen);
  const screens = useSelectorWall((state) => state.wall.screens);
  const dimensionsScreen = useMemo<ScreenDimension>(
    () => getScreenDimensions(type, profileScreen),
    [profileScreen, type],
  );
  const columns = profileScreen.columns ?? 1;
  const rows = profileScreen.rows ?? 1;
  const screenTotalDevice = columns * rows;
  const screenTotalProfile = screens.length;
  const screenOffset =
    screenTotalProfile < screenTotalDevice
      ? Math.floor((screenTotalDevice - screenTotalProfile) / 2)
      : 0;

  return (
    <>
      {Array.from({ length: columns }).map((_, col) =>
        Array.from({ length: rows }).map((_, row) => {
          const screen = screens[col + row * columns - screenOffset];

          if (!screen) {
            return null;
          }

          return (
            <div
              key={`${col}:${row}`}
              className="absolute overflow-hidden"
              style={{
                ...dimensionsScreen,
                left: col * dimensionsScreen.width,
                top: row * dimensionsScreen.height,
              }}
            >
              <Screen screen={screen} />
            </div>
          );
        }),
      )}
    </>
  );
}

export function Screens() {
  const type = useSelectorWall((state) => state.wall.type);

  return (
    <div
      id={SCREENS_DIV_ID}
      className="absolute left-0 top-0 w-full h-full overflow-hidden"
    >
      {type === ScreenType.Custom && <ScreenCustom />}
      {type === ScreenType.Tv && <ScreenTv />}
    </div>
  );
}
